import React, {FunctionComponent, useEffect, useState} from "react";
import {Box, useTheme} from "@mui/material";
import { useAppSelector} from "../../../../../../Config/Hooks";
import {addMinutes, endOfDay, format, parseISO} from "date-fns";
import {isArray} from "lodash";
import {truncateNumber} from "../../../../../../Utils/NumberUtil";
import {AChartX, Skeleton} from "@atiautomacao/ati-ui-library";
import DataNotFound from "../../../../../../Shared/Components/DataNotFoundMessage";
import {FindStringCurrentByEquipmentId} from "../../InverterReactQuery";
import {LocalDateTimeFormatISO} from "../../../../../../Utils/DateFormatPatternUtils";

let intervalDate:Array<string> = [];

interface StringCurrent{
    teleObjectId: number,
    name: string,
    dateTime: Date,
    value: number,
}

const HeatMapChartStringCurrent: FunctionComponent<{equipmentId: number, date:Date}> = ({equipmentId, date}) => {
    const theme = useTheme();
    const openSubMenu = useAppSelector((state: any) => state.layout.openSubMenu);
    const [startDate, setStartDate] = useState<string>();
    const [endDate, setEndDate] = useState<string>();
    const { data, isLoading } = FindStringCurrentByEquipmentId(equipmentId, startDate, endDate);
    const [series, setSeries] = useState<Array<any>>([]);
    const [dataPU, setDataPU] = useState<Array<StringCurrent>>([]);
    const [maxValue, setMaxValue] = useState<number>(0);

    useEffect(() => {
        if(data?.data && equipmentId){
            setDataPU(data?.data)
        }else{
            setDataPU([])
        }
    }, [data, equipmentId, startDate, endDate]);

    useEffect(() => {
        setStartDate(LocalDateTimeFormatISO(date))
        setEndDate(LocalDateTimeFormatISO(endOfDay(date)))
    }, [date]);

    useEffect(() => {
        const maxValueBrute = series.reduce((currentMax, item) => {
            const maxPerItem = Math.max(...item.data);
            return Math.max(currentMax, maxPerItem);
        }, -Infinity);
        const maxValueFinal = Math.ceil(maxValueBrute / 5) * 5
        setMaxValue(Math.max(maxValueFinal || 0, 5))
    }, [series]);

    const ordinalAxes = () => {
        let matrix:any = []
        for(let line = 0; line < series.length; line ++) {
            for (let column = 0; column < series[line].data.length; column++) {
                matrix.push([column,line, series[line].data[column]]);
            }
        }
        return matrix;
    }

    const callback = (args:any) => {
        const {name, data, value} = args;
        let names = series.map(el => el.name);
        return  'Horário' + ': ' + '<strong> '  +  name + '</strong>' + '<br />' + args.marker + ' ' + names[value[1]] + ' - ' + 'Gerado: ' + '<strong> '  +  data[2] + '</strong>'
    }

    const adjustDataPoints = (dataPoints: any[]): any[] => {
        if (dataPoints.length === 0) {
            return dataPoints;
        }

        // Parseia o primeiro e último dateTime para objetos Date
        const firstDateTime = parseISO(dataPoints[0].dateTime);
        const lastDateTime = parseISO(dataPoints.at(-1).dateTime);
        const teleObjectId = dataPoints[0].teleObjectId
        const name = dataPoints[0].name

        // Horários limite
        const startTime = new Date(firstDateTime);
        startTime.setHours(4, 0, 0, 0); // 4:00
        const endTime = new Date(lastDateTime);
        endTime.setHours(20, 0, 0, 0); // 20:00

        let newData = [...dataPoints]
        while (firstDateTime > startTime) {
            const newDateTime = addMinutes(firstDateTime, -5);
            newData.unshift({
                dateTime: format(newDateTime, 'yyyy-MM-dd HH:mm:ss.S'),
                teleObjectId: teleObjectId,
                name: name,
            });
            firstDateTime.setTime(newDateTime.getTime());
        }

        while (lastDateTime < endTime) {
            const newDateTime = addMinutes(lastDateTime, 5);
            newData.push({
                dateTime: format(newDateTime, 'yyyy-MM-dd HH:mm:ss.S'),
                teleObjectId: teleObjectId,
                name: name,
            });
            lastDateTime.setTime(newDateTime.getTime());
        }

        return newData;
    }


    useEffect(() => {

        const newData:Array<any> = [];

        if(isArray(dataPU) && dataPU && dataPU.length > 0){
            let datePeriod: any[];
            let entities = adjustDataPoints(dataPU)
            datePeriod = Array.from(new Set(
                entities.map(
                    item => item.dateTime
                )
            ));

            intervalDate = datePeriod.map(
                item => format(new Date(item), 'HH:mm')
            );

            // SORT BY NAME EQUIPMENT DESC
            const equipmentEntitySort = [...dataPU].sort((a, b) => {
                return a.name.localeCompare(b.name, undefined, { numeric: true, sensitivity: 'base' });
            });


            // IDENTIFY INVERTER DISTINCT BY IDs
            const uniqueEquipmentIds = Array.from(new Set(equipmentEntitySort.map(item => item.teleObjectId)));
            // INSERT THE DATA BY INVERTER ID
            uniqueEquipmentIds.forEach(element => {
                let filter = equipmentEntitySort.filter(data => data.teleObjectId === element);
                let dataEquipment = adjustDataPoints(filter)
                newData.push(
                    {
                        name: filter[0].name,
                        data: dataEquipment.map(element => element.value == null ? '-' : truncateNumber(element.value, 2)),
                    },
                )
            })
            const newDataSort = [...newData].sort((a,b) => {
                return a.name.localeCompare(b.name, undefined, { numeric: true, sensitivity: 'base' });
            })
            setSeries(newDataSort);
        }else {
            setSeries([])
        }

    }, [dataPU]);


    // @ts-ignore
    const option: AChartXProps['option'] = {
        tooltip: {
            trigger: 'item',
            //formatter: callback,
            textStyle: {
                fontSize: 16
            },
        },
        grid: {
            show: true,
            containLabel: true,
            height: '80%',
            top: '10%',
            left: '2%',
        },
        xAxis: {
            type: 'category',
            data: intervalDate,
            name: "Horário",
            nameLocation: 'middle',
            min: '04:00',
            max: '20:00',
            nameGap: 30,
            splitArea: {
                show: true
            }
        },
        yAxis: {
            type: 'category',
            data: series.map(el => el.name),
            axisLabel: {
                fontSize: 10
            },
            inverse: true
        },
        visualMap: {
            min: 0,
            max: maxValue,
            calculable: true,
            itemHeight: 220,
            left: 'right',
            top: 'center',

        },
        animationDuration: 2000,
        dataZoom :[
            {
                type: 'slider',
                startValue: 0,
                yAxisIndex: [0],
                filterMode: 'filter',
                zoomLock: true,
                fillerColor: '#B3B6B7',
                maxValueSpan: 8,
                width: 10,
                height: 315,
                right: 60,
                top: '10%',
                bottom: '10%',
                brushSelect: false,
                handleSize: '30%',
                showDetail: false,
                opacity: 1,
                brushStyle: false,
                throttle: 50
            },
            {
                type: 'inside',
                id: 'insideY',
                yAxisIndex: [0],
                zoomOnMouseWheel: false,
                moveOnMouseMove: true,
                moveOnMouseWheel: true,
                backgroundColor: 'transparent'
            }
        ] ,
        series: [
            {
                type: "heatmap",
                id: 'heatmap',
                data: ordinalAxes(),
                itemStyle: {
                    borderWidth:0.5,
                    borderColor: "#FFFFFF"
                },
                emphasis: {
                    itemStyle: {
                        borderColor: "#d4d4d4",
                        borderWidth: 1
                    }
                }
            }
        ],
    };
    option.tooltip.formatter = callback;
    const [content, setContent] = useState<JSX.Element>()

    useEffect(() => {
        if(isLoading){
            setContent(<Skeleton animation="wave" height={400} variant="rounded" width={"100%"} />)
        }else if(series.length > 0 && dataPU.length > 0){
            setContent(<AChartX
                key={`heatmap-${openSubMenu}`}
                option={option}
                width={'100%'}
                height={420}
                loading={false}
                theme={theme.palette.mode}
                restoreOnDoubleClick={true}
            />)
        }else {
            setContent(
                <Box sx={{ height: 400 }}>
                    <DataNotFound/>
                </Box>
            )
        }
    }, [series, isLoading, maxValue, openSubMenu]);

    return (
            <>
                {content != null && content}
            </>
    )
}

export default HeatMapChartStringCurrent;